const CITIES = [
  'Oakland, IL', 'Camargo, IL', 'Newman, IL', 'Hindsboro, IL',
  'Kansas, IL', 'Tuscola, IL', 'Mattoon, IL', 'Charleston, IL',
  'Arcola, IL', 'Sullivan, IL', 'Paris, IL', 'Villa Grove, IL',
  'Coles County', 'Douglas County', 'Edgar County', 'Moultrie County',
];

export default function ServiceAreas() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="inline-block w-10 h-px bg-gold opacity-70"></span>
            <p className="text-gold text-xs font-bold uppercase tracking-[0.2em]">Senior Care Near Me</p>
            <span className="inline-block w-10 h-px bg-gold opacity-70"></span>
          </div>
          <h2 className="font-heading text-navy font-bold mb-4 leading-tight" style={{ fontSize: 'clamp(1.9rem, 3.5vw, 3.2rem)' }}>
            Serving Seniors in Your Community
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Oak Senior Care proudly provides in-home senior care throughout Oakland, IL and East-Central Illinois. Wherever your loved one calls home, our compassionate caregivers are nearby and ready to help.
          </p>
        </div>

        {/* LARGE Full-Width Map */}
        <div
          className="rounded-2xl overflow-hidden border border-gray-200 mb-8 relative"
          style={{ height: '560px' }}
        >
          {/* Map overlay bar */}
          <div className="absolute top-4 left-4 z-10 bg-white rounded-xl px-5 py-3 flex items-center gap-3 border border-gray-100"
            style={{ boxShadow: '0 4px 20px rgba(15,42,68,0.12)' }}>
            <span className="w-8 h-8 flex items-center justify-center bg-gold/15 rounded-full">
              <i className="ri-map-pin-fill text-gold text-base"></i>
            </span>
            <div>
              <p className="font-bold text-navy text-sm leading-tight">Oak Senior Care</p>
              <p className="text-gray-400 text-xs">111 South Walnut, Oakland, IL 61943</p>
            </div>
          </div>
          <iframe
            title="Oak Senior Care Service Area Map - Oakland IL"
            src="https://maps.google.com/maps?q=111+South+Walnut,+Oakland,+IL+61943&t=&z=11&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
          />
        </div>

        {/* Bottom info row */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* City tags */}
          <div className="lg:col-span-2 bg-offWhite rounded-2xl p-8 border border-gray-100">
            <div className="flex items-center gap-3 mb-2">
              <i className="ri-map-2-line text-navy text-lg"></i>
              <h3 className="font-heading text-navy text-xl font-bold">Areas We Serve</h3>
            </div>
            <p className="text-gray-500 text-sm mb-6">Senior care in Oakland, IL and all surrounding communities — we come to you.</p>
            <div className="flex flex-wrap gap-2">
              {CITIES.map((city) => (
                <span
                  key={city}
                  className="inline-flex items-center gap-1.5 bg-white border border-gray-200 text-navy text-xs font-medium px-4 py-2 rounded-full hover:border-sage hover:bg-sage/8 transition-all cursor-default"
                >
                  <i className="ri-map-pin-line text-sage text-xs"></i>
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* Contact card */}
          <div
            className="rounded-2xl p-8 flex flex-col justify-between relative overflow-hidden"
            style={{ background: 'linear-gradient(150deg, #0F2A44 0%, #1a3d5c 100%)' }}
          >
            <div className="absolute top-0 right-0 w-40 h-40 rounded-full opacity-10 pointer-events-none"
              style={{ background: 'radial-gradient(circle, rgba(200,169,106,1) 0%, transparent 70%)', transform: 'translate(40%, -40%)' }} />
            <div className="relative z-10">
              <p className="text-gold text-xs font-bold uppercase tracking-[0.18em] mb-5">Contact Us Directly</p>
              <address className="not-italic text-white/75 text-sm leading-relaxed mb-6">
                <strong className="text-white text-base">111 South Walnut</strong><br />
                Oakland, IL 61943
              </address>
              <div className="space-y-3.5 mb-7">
                <a href="tel:2173462042" className="flex items-center gap-3 text-white font-semibold text-sm hover:text-gold transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center bg-gold/20 rounded-full">
                    <i className="ri-phone-fill text-gold text-sm"></i>
                  </span>
                  (217) 346-2042
                </a>
                <a href="tel:9417991552" className="flex items-center gap-3 text-white/60 text-sm hover:text-gold transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full">
                    <i className="ri-phone-line text-white/50 text-sm"></i>
                  </span>
                  (941) 799-1552
                </a>
                <a href="mailto:eric@alhusa.com" className="flex items-center gap-3 text-white/60 text-sm hover:text-gold transition-colors">
                  <span className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full">
                    <i className="ri-mail-line text-white/50 text-sm"></i>
                  </span>
                  eric@alhusa.com
                </a>
              </div>
            </div>
            <a
              href="https://maps.app.goo.gl/PREvdTkT8jNmMXEJ6"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap relative z-10 inline-flex items-center justify-center gap-2 bg-gold text-navy text-sm font-bold px-6 py-3.5 rounded-full hover:brightness-110 transition-all"
            >
              <i className="ri-map-pin-line"></i>
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
